<template>
    <transition
        name="bmv-collapse"
        @before-enter="onBeforeEnter"
        @enter="onEnter"
        @before-leave="onBeforeLeave"
        @leave="onLeave"
    >
        <div v-if="open" class="bmv-collapse">
            <slot />
        </div>
    </transition>
</template>

<script>
const ENTER_DURATION = 220
const LEAVE_DURATION = 180

export default {
    name: 'BmvCollapse',
    props: {
        open: { type: Boolean, default: false }
    },
    methods: {
        onBeforeEnter(el) {
            el.style.height = '0'
            el.style.opacity = '0'
            el.style.overflow = 'hidden'
        },
        onEnter(el, done) {
            void el.offsetHeight
            el.style.transition = `height ${ENTER_DURATION}ms cubic-bezier(0.22, 1, 0.36, 1), opacity ${ENTER_DURATION}ms ease`
            el.style.height = `${el.scrollHeight}px`
            el.style.opacity = '1'
            const handler = () => {
                el.removeEventListener('transitionend', handler)
                el.style.height = 'auto'
                el.style.transition = ''
                el.style.overflow = ''
                done()
            }
            el.addEventListener('transitionend', handler, { once: true })
        },
        onBeforeLeave(el) {
            el.style.height = `${el.scrollHeight}px`
            el.style.opacity = '1'
            el.style.overflow = 'hidden'
        },
        onLeave(el, done) {
            void el.offsetHeight
            el.style.transition = `height ${LEAVE_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), opacity ${LEAVE_DURATION}ms ease`
            el.style.height = '0'
            el.style.opacity = '0'
            const handler = () => {
                el.removeEventListener('transitionend', handler)
                el.style.transition = ''
                done()
            }
            el.addEventListener('transitionend', handler, { once: true })
        }
    }
}
</script>

<style scoped>
.bmv-collapse {
    will-change: height, opacity;
}
</style>
